<template>
  <div>
    <form-components @submitForm="submitForm">
      <template v-slot:content>
        <el-form-item label="原始密码" :show-password=true>
            <el-col :span="8">
              <el-input v-model="userPass.oldPass" :show-password=true></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="新密码">
            <el-col :span="8">
              <el-input v-model="userPass.newPass" :show-password=true></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-col :span="8">
              <el-input v-model="userPass.confirmPass" :show-password=true></el-input>
            </el-col>
          </el-form-item>
      </template>
    </form-components>
  </div>
</template>

<script>
import FormComponents from "@/components/form/FormComponents";
import LoginApi from '@/api/LoginApi'
import {deleteLocalStorageItem} from '@/utils/localstorage/LocalstorageKit'
export default {
  name: "ModifyUserPassPage",
  props: {
    msg: String,
  },
  components: {
    FormComponents
  },
  data() {
    return {
      userPass:{
        oldPass:"",
        newPass:"",
        confirmPass:""
      }
    }
  },
  methods:{
    submitForm(){
      LoginApi.modifyPass(this.userPass).then((resp)=>{
        if(resp.state=="OK"){
          this.userPass={}
          this.$successMsg(resp.msg)
          deleteLocalStorageItem("token");
          deleteLocalStorageItem("userInfo");
          setTimeout(()=>{
            window.location.href="/login"
          },1000)
        }else{
          this.$errorMsg(resp.msg)
        }
      })
    }
  }
};
</script>

